/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Badge } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import useStore from '../../store';
import { useDebounceEffect } from '../form/useDebounceEffect';

const Q_COUNT_UNREAD_PROPOSALS = gql`
	query get($auditServiceOnly: Boolean) {
		getCountUnreadCompanySubmissionProposals(auditServiceOnly: $auditServiceOnly)
	}
`;

const Q_COUNT_NEARLYDUE_PROPOSALS = gql`
	query get($auditServiceOnly: Boolean) {
		getCountNearlyDueCompanySubmissionProposals(auditServiceOnly: $auditServiceOnly)
	}
`;

function CompanySubmissionProposalBadge({ auditServiceOnly = false }) {
	const { t } = useTranslation();
	const { countUnreadNotifications } = useStore((state) => state?.countUnreadNotifications);
	const [loadCountUnreadComplaints, { data: count }] = useLazyQuery(Q_COUNT_UNREAD_PROPOSALS);
	const [loadCountNearlyDueComplaints, { data: countNearlyDue }] = useLazyQuery(Q_COUNT_NEARLYDUE_PROPOSALS);

	useDebounceEffect(load, 200, [countUnreadNotifications]);

	function load() {
		loadCountUnreadComplaints({ variables: { auditServiceOnly } });
		loadCountNearlyDueComplaints({ variables: { auditServiceOnly } });
	}

	return (
		<>
			{parseInt(count?.getCountUnreadCompanySubmissionProposals || 0) > 0 && (
				<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
					{parseInt(count?.getCountUnreadCompanySubmissionProposals || 0)}
				</Badge>
			)}
			{parseInt(countNearlyDue?.getCountNearlyDueCompanySubmissionProposals || 0) > 0 && (
				<Badge zIndex="99" top="2px" left="2px" position="absolute" colorScheme="yellow" fontSize="16px">
					{parseInt(countNearlyDue?.getCountNearlyDueCompanySubmissionProposals || 0)} {t('Nearly Due')}
				</Badge>
			)}
		</>
	);
}

export default CompanySubmissionProposalBadge;
